function Tooltip({ text, children }: { text: string; children: React.ReactNode }) {
  return (
    <span className="group relative inline-block">
      {children}
      <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2 py-1 rounded bg-gray-800 text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 shadow-lg">
        {text}
        <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
      </span>
    </span>
  );
}

const SUPERCLASS_COLORS: Record<string, string> = {
  NORM: "bg-green-100 text-green-800",
  MI: "bg-red-100 text-red-800",
  STTC: "bg-yellow-100 text-yellow-800",
  CD: "bg-blue-100 text-blue-800",
  HYP: "bg-purple-100 text-purple-800",
};

export function Badge({ label, type }: { label: string; type?: string }) {
  const colorClass = type && SUPERCLASS_COLORS[type] ? SUPERCLASS_COLORS[type] : "bg-gray-100 text-gray-800";
  return (
    <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded ${colorClass}`}>
      {label}
    </span>
  );
}

export function SCPCodeBadge({ code, description }: { code: string; description?: string }) {
  return (
    <Tooltip text={description || code}>
      <span className="inline-block px-1.5 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-700 border border-gray-200">
        {code}
      </span>
    </Tooltip>
  );
}